export default function Community() {
  return (
    <section className="relative mt-4 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20crowd%20silhouettes%20holding%20phones%20in%20a%20night%20arena%2C%20glowing%20crimson%20and%20amber%20lights%2C%20faceless%20audience%2C%20dramatic%20backlight%2C%20cinematic%20editorial%20gossip%20culture%2C%20high%20contrast%2C%20clean%20composition%2C%20artistic%20abstract&width=1600&height=620&seq=cta-community&orientation=landscape"
        alt="抖阴黑料吃瓜社群入口"
        title="抖阴黑料 · 吃瓜社群"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/45" />

      <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col items-start gap-6 px-4 py-16 md:px-6 md:py-20">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-white/20 bg-white/5 px-3 py-1.5 text-xs text-white/85 backdrop-blur">
          <i className="ri-team-fill text-accent-400" />
          全网吃瓜群众 · 已加入 42w+
        </span>
        <h2 className="max-w-2xl font-heading text-3xl font-black leading-tight text-white md:text-5xl">
          塌房名单还在更新
          <br />
          下一个瓜，你不想错过
        </h2>
        <p className="max-w-xl text-sm leading-relaxed text-white/75 md:text-base">
          进群第一时间收到名单更新与打包提醒，和几十万同好一起扒进度，
          从此不再「慢人一步」。
        </p>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            href="#download"
            className="inline-flex h-12 items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-group-2-fill mr-2 text-lg" />
            加入吃瓜社群
          </a>
          <a
            href="#download"
            className="inline-flex h-12 items-center justify-center whitespace-nowrap rounded-md border border-white/25 bg-white/10 px-6 text-sm font-semibold text-white backdrop-blur transition-colors hover:bg-white/20"
          >
            领取今日打包合集
          </a>
        </div>
      </div>
    </section>
  );
}